import React, { Component } from "react";

// @material-ui/icons
import ViewModule from "@material-ui/icons/ViewModule";
import SearchIcon from '@material-ui/icons/Search';
// core components
import CustomTabs from "components/CustomTabs/CustomTabs.js";
import LockerStruct from 'components/LockerStruct';
import SearchSocicam from 'components/Search/SearchSocicam';

class SocicamLockerOptions extends Component {
  render() {
    const { lockerId } = this.props;
    return (
      <CustomTabs
        title="Locker Info:"
        headerColor="primary"
        tabs={[
          {
            tabName: "Locker",
            tabIcon: ViewModule,
            tabContent: (
              <LockerStruct lockerId={lockerId} />
            )
          },
          {
            tabName: "Pesquisa",
            tabIcon: SearchIcon,
            tabContent: (
              <SearchSocicam lockerId={lockerId} />
            )
          }
        ]}
      />

    )
  }
}

export default SocicamLockerOptions;